import { inject, Injectable } from '@angular/core';
import { WebProviderService } from '../web/web.provider.service';
import { assert } from 'src/app/utils/assert.util';
import { Price } from 'src/app/interfaces/Price';
import { environment } from 'src/environments/environment';
import { CustomMarkups } from 'src/app/interfaces/CustomMarkups';

@Injectable({
  providedIn: 'root'
})
export class PriceProviderService {
  private webProvider = inject(WebProviderService);
  private readonly baseURL = environment.apiURL;
  private get attributeURL() {
    return '/api/prices';
  }

  async getCustomMarkups(retailerRingBuilderID: string): Promise<CustomMarkups> {
    const customMarkups = await this.webProvider.get<CustomMarkups>(`${this.baseURL}${this.attributeURL}/CustomItemData?ringBuilderID=${retailerRingBuilderID}`);
    assert(customMarkups, 'Failed to fetch custom item data');
    return customMarkups;
  }

  /** @deprecated Use {@link getCustomMarkups} with a `ringBuilderID` instead. */
  async getCustomMarkupsByHALOID(retailerHALOID: number): Promise<CustomMarkups> {
    const customMarkups = await this.webProvider.get<CustomMarkups>(`${this.baseURL}${this.attributeURL}/CustomItemData/Legacy?haloID=${retailerHALOID}`);
    assert(customMarkups, 'Failed to fetch custom item data');
    return customMarkups;
  }

  async getPrice(pc: string, baseFormNumber: string, fingerSize: number): Promise<Price> {
    const price = await this.webProvider.get<Price>(`${this.baseURL}${this.attributeURL}?pc=${pc}&styleNumber=${baseFormNumber}&fingerSize=${fingerSize}`);
    assert(price, 'Failed to fetch price for style');
    return price;
  }

  async getRetailerPrice(retailerIframeID: string, baseFormNumber: string, fingerSize: number): Promise<Price> {
    const price = await this.webProvider.get<Price>(`${this.baseURL}/api/retailers/${retailerIframeID}/price?styleNumber=${baseFormNumber}&fingerSize=${fingerSize}`);
    assert(price, 'Failed to fetch price for style');
    return price;
  }

  async getRetailPrice(pc: string, baseFormNumber: string, fingerSize: number): Promise<Price> {
    const url = new URL(`${this.baseURL}${this.attributeURL}/Retail`);
    if (pc) {
      url.searchParams.set('pc', pc);
    }
    url.searchParams.set('styleNumber', baseFormNumber);
    url.searchParams.set('fingerSize', fingerSize.toString());
    const price = await this.webProvider.get<Price>(url.toString());
    assert(price, 'Failed to fetch price for style');
    return price;
  }

  async getPriceWithHALOItemNumberByRingBuilderID(ringBuilderID: string, haloItemNumber: string, fingerSize: number): Promise<Price> {
    const price = await this.webProvider.get<Price>(`${this.baseURL}${this.attributeURL}/byRingBuilderIDwithHALOItemNumber?ringBuilderID=${ringBuilderID}&styleNumber=${haloItemNumber}&fingerSize=${fingerSize}`);
    assert(price, 'Failed to fetch price for style');
    return price;
  }

  async getRetailerPriceWithHALOItemNumber(retailerIframeID: string, haloItemNumber: string, fingerSize: number): Promise<Price> {
    const price = await this.webProvider.get<Price>(`${this.baseURL}/api/retailers/${retailerIframeID}/priceWithHALOItemNumber?styleNumber=${haloItemNumber}&fingerSize=${fingerSize}`);
    assert(price, 'Failed to fetch price for style');
    return price;
  }

}
